import React from "react";
import { useSelector } from "react-redux";
import ForgotPasswordLanding from "./ForgotPasswordScreens/ForgotPasswordLanding";

const ForgotPasswordPage = () => {
  const status = useSelector((state) => state.forgotPassword.status);
  return (
    <>
      {status === "idle" && <ForgotPasswordLanding />}
    </>
  );
};

export default ForgotPasswordPage;
